import { withChartLayout } from 'components/common';
import HygieneDressingsComfort from 'components/features/chart/basic-nursing-care/hygiene-dressings-comfort/HygieneDressingsComfort';

const HygieneDressingsComfortPage = withChartLayout('Hygiene - Dressings - Comfort')(HygieneDressingsComfort);
export default HygieneDressingsComfortPage;
